/**
 * User-facing summary for bulk AI match API responses.
 */
export function summarizeAiMatchResults(results) {
  const list = Array.isArray(results) ? results : [results];
  if (list.some((r) => r?.accepted && r?.status === 'running')) {
    const remaining = list.filter((r) => !(r?.accepted && r?.status === 'running'));
    if (remaining.length === 0) {
      return 'AI matching is running in the background. You can switch pages — progress stays on AI Watch until it finishes.';
    }
  }
  const upserted = list.reduce((sum, r) => sum + (r?.upserted || 0), 0);
  const removed = list.reduce((sum, r) => sum + (r?.below_threshold_removed || 0), 0);
  const failures = list.flatMap((r) => r?.failures || []);
  const lines = [
    `AI matching finished: ${upserted} pairs saved, ${removed} below threshold removed.`,
  ];
  if (failures.length) {
    const sample = [...new Set(failures.map((f) => f.error).filter(Boolean))].slice(0, 2);
    lines.push(`${failures.length} scoring error(s).`);
    if (sample.length) lines.push(sample.join(' '));
  }
  return lines.join('\n');
}
